import { render, staticRenderFns } from "./incomeTaxDeclarationDashboard.vue?vue&type=template&id=632dd6ce&scoped=true"
import script from "./incomeTaxDeclarationDashboard.vue?vue&type=script&lang=js"
export * from "./incomeTaxDeclarationDashboard.vue?vue&type=script&lang=js"
import style0 from "./incomeTaxDeclarationDashboard.vue?vue&type=style&index=0&id=632dd6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632dd6ce",
  null
  
)

export default component.exports